import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import { Link } from 'react-router-dom';
import WithConsumer from '../context/WithConsumer';

const DesktopMenu = ({ context }) => {
	
	const ctxMenu 	= () => context.menu;
	const menu 		= ctxMenu();
	
	let timer 		= null;
    
    function handleClick(evt){
	    if (evt.target.getAttribute('href') === '#') {
		    evt.preventDefault();
	    }
	}
    
    function handleMouseOver(evt){
	    if (menu.interactive === true) {
	    
			let index = parseFloat(evt.target.getAttribute('data-index'));
					
		    if (timer !== null) {
			    clearTimeout(timer);
			    timer = null;
		    }
		    timer = setTimeout(() => {
			    if (menu.currentPanel !== -1) {
					context.setMenuState(index,false,false);
				} else {
				    context.setMenuState(index,true,false);
			    }
		    }, 350);
	    }
    }
    
    function handleMouseOut(){
		if (menu.interactive === true) {	    	    
		    if (timer !== null) {
			    clearTimeout(timer);
			}
			timer = setTimeout(() => {
				context.setMenuState(-1,true,true);
			}, 500);
		}
    }
    
    function isTouchDevice() {
	   if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
		   return true;
	   } else {
		   return false;
	   }
	}
    
	if (menu.json.menu !== null) {
		
    	const items = [];
    	for (let i=0;i<menu.json.menu.length;i++) {
	    	let itemClass = "c-menu__link";
	    	if (menu.json.menu[i].subitems) {
		    	itemClass = itemClass + " c-menu__link--has-children";	
		    }
			items.push(<li className="c-menu__item" data-index={i} key={i}>
				<Link to={{ pathname: menu.json.menu[i].url }} className={ itemClass } onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={handleClick} data-index={i}>{ menu.json.menu[i].title }</Link>
			</li>);
		}
		const panels = [];
		let count = 0;
		for (let i=0;i<menu.json.menu.length;i++) {
			if (menu.json.menu[i].subitems) {
				let subitems = [];
				for (let j=0;j<menu.json.menu[i].subitems.length;j++) {
					subitems.push(<li className="c-menu__panel__item" key={count}><Link to={{ pathname: menu.json.menu[i].subitems[j].url }} onClick={handleClick}>{menu.json.menu[i].subitems[j].title}</Link></li>);
					count = count + 1;
				}
				let panelClass = 'c-menu__panel';
				if (menu.currentPanel === i) {
					panelClass += ' state-active';
				}
				if (menu.animateIn === true) {
					panelClass += ' state-animate-in';
				}
				if (menu.animateOut === true) {
					panelClass += ' state-animate-out';
				}
				let empty = [];
				let features = [];
				if (menu.json.menu[i].feature) {
					for (let j=0;j<(3 - menu.json.menu[i].feature.length);j++) {
						empty.push(<div key={j} className="l-grid__col l-grid__col--l-3-12"></div>);
					}
					for (let j=0;j<menu.json.menu[i].feature.length;j++) {
						features.push(<div key={j} className="l-grid__col l-grid__col--l-3-12 c-menu__panel__feature-block">
							<Link onClick={handleClick} to={{ pathname: menu.json.menu[i].feature[j].url }} className="c-menu__panel__feature">
								<div className="c-menu__panel__feature__image">
									<FadeIn duration={250}>
										{onload => (
											<img
												alt=''
												src={menu.json.menu[i].feature[j].src} 
												srcSet={menu.json.menu[i].feature[j].srcset} 
												onLoad={onload}
											/>
										)}
									</FadeIn>
								</div>
								<h5 className="c-menu__panel__feature__heading">{menu.json.menu[i].feature[j].heading}</h5>
								<p className="c-menu__panel__feature__text">{menu.json.menu[i].feature[j].text}</p>
							</Link>
						</div>);
					}
				}
				if (isTouchDevice() === true) {
					panels.push(
						<div key={i} className={panelClass} data-index={i}>
							<div className="c-menu__panel__inner c-menu__panel__inner--touch" data-index={i}>
								<div className="l-grid">
									<div className="l-grid__col l-grid__col--l-3-12">
										<ul className="c-menu__panel__list">{subitems}</ul>
									</div>
									{ empty }
									{ features }
								</div>
							</div>
						</div>
					);
				} else {
					panels.push(
						<div key={i} className={panelClass} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} data-index={i}>
							<div className="c-menu__panel__inner c-menu__panel__inner--no-touch" data-index={i}>
								<div className="l-grid">
									<div className="l-grid__col l-grid__col--l-3-12">
										<ul className="c-menu__panel__list">{subitems}</ul>
									</div>
									{ empty }
									{ features }
								</div>
							</div>
						</div>
					);
				}
			}
		}
    	return (
    		<div className="c-menu">
    			<ul className="c-menu__list">
    				{ items }
    			</ul>
    			{ panels }
    		</div>
    	)
	} else {
		return null;
	}
}
export default WithConsumer(DesktopMenu);